// see: https://github.com/chakra-ui/chakra-ui/blob/main/packages/components/theme/src/components/number-input.ts
import { inputTheme } from './input'

export const numberInputTheme = {
    sizes: {
        md: {
            field: {
                ...inputTheme.sizes.md.field,
            },
        },
    },
    fontFamily: 'fonts',
    variants: inputTheme.variants,
    defaultProps: inputTheme.defaultProps,
}
